import { LauraAvatar } from 'components/atoms/Avatar';
import { FC } from 'react';
import styled from 'styled-components';
import Spacing from '@components/atoms/Spacing';
import ChatMessage from './ChatMessage';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;

  img {
    margin-right: 10px;
    margin-bottom: 5px;
    margin-top: 10px;
  }
`;

const BotExplanation: FC = ({ children }) => (
  <Wrapper>
    <LauraAvatar size={36} />
    <Spacing horizontal={0.5} />
    <ChatMessage
      first
      bot
      text={children}
      id="explanation"
      ignoreMaxWidth
      fontSize={16}
    />
  </Wrapper>
);

export default BotExplanation;
